import React from 'react';
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, EmailShareButton } from 'react-share';
import styles from './ShareListNotPopUp.css';
import Linkedin from './img/linkedinSocial.svg';
import Facebook from './img/facebookSocial.svg';
import Twitter from './img/twitterSocial.svg';
import Mail from './img/email2.svg';
import ReactWOW from '../../../components/react-wow/src';
import { getSwitchClassNameOrColourWithBackground } from '../../../utils/func';

/**
 *
 * @type {React.NamedExoticComponent<{urlShare?: *, titleQuiz?: *, backgroundColor?: *, quizType?: *}>}
 */

const ShareListNotPopUp = React.memo( ( { titleQuiz, backgroundColor, urlShare, quizType } ) => {

    const placeholderColor = getSwitchClassNameOrColourWithBackground( backgroundColor, 'light', 'darkBg' );
    const isPersTest = ( quizType === 'person' );
    const containerStyle = 'light' === placeholderColor ? styles.containerSocialLinkDark : styles.containerSocialLink;

    return (
        <ReactWOW animation='fadeInUp'  duration='0.5s'>
            <div className={ styles.wrapper }>
                <div className={ `${ containerStyle }` }>
                    <LinkedinShareButton url={ `${ urlShare }` } title={ titleQuiz ? titleQuiz : '' }>
                        <Linkedin style={ isPersTest ? { marginBottom: '0' } : {} }/>
                    </LinkedinShareButton>
                    <FacebookShareButton url={ `${ urlShare }` }>
                        <Facebook style={ isPersTest ? { marginBottom: '0' } : {} }/>
                    </FacebookShareButton>
                    <TwitterShareButton url={ `${ urlShare }` }>
                        <Twitter style={ isPersTest ? { marginBottom: '0' } : {} }/>
                    </TwitterShareButton>
                    <EmailShareButton url={ `${ urlShare }` }>
                        <Mail style={ isPersTest ? { marginBottom: '0' } : {} }/>
                    </EmailShareButton>
                </div>

            </div>
        </ReactWOW>
    );
} );

export default ShareListNotPopUp;